import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Confirm } from "../../components/confirm";
import { deleteLease } from "../../services/lease";
import { useLocale } from "../../stores/locale";
import { navigateBack } from "../../utils/navigate-back";

export function LeaseDelete() {
  const navigate = useNavigate();
  const locale = useLocale((state) => state);
  const queryClient = useQueryClient();
  const { id } = useParams();

  if (!id) {
    throw new Error("Lease ID is required");
  }

  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    navigateBack(navigate, "/admin/register/lease");
  };

  return (
    <>
      <Confirm
        header={locale.get("lease.confirmDelete")}
        loading={loading}
        onClose={closeModal}
        onConfirm={() => {
          (async () => {
            setLoading(true);
            try {
              await deleteLease(id);
              await queryClient.invalidateQueries({ queryKey: ["leases"] });
            } finally {
              setLoading(false);
              closeModal();
            }
          })();
        }}
      />
    </>
  );
}
